import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { RecCard } from '../video-detail-recs';

/** Horizontal "More from <arena>" row under the player. Presentation only: the page opens the album. */
@Component({
  selector: 'app-vd-recs',
  templateUrl: './vd-recs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VdRecsComponent {
  @Input() title = '';
  @Input() cards: RecCard[] = [];
  @Output() open = new EventEmitter<RecCard>();
  @ViewChild('strip') strip?: ElementRef<HTMLElement>;

  scroll(direction: 1 | -1): void {
    const el = this.strip?.nativeElement;
    if (el) el.scrollBy({ left: direction * el.clientWidth * 0.85, behavior: 'smooth' });
  }

  trackByCard(_: number, card: RecCard): number {
    return card.id;
  }
}
